import getNewTreeMenu from './menu.sdk'
import getSubMenuList from './router.sdk'
import { dataBase } from 'blm-utils'

const db = new dataBase.DB('web_blm', 'resource')

async function get({
  routers,
  platformName,
  resourceList = [],
  isBlacklist = false,
  request,
}) {
  const menuList = getMenuList({ routers, platformName, resourceList })
  const filterRouter = getAuthorizedRouter({ routers, platformName, menuList })
  let navMenu = resourceList.map((item) => ({
    name: item.resourceName,
    key: item.resourceKey,
  }))
  if (!isBlacklist && request) {
    try {
      // blacklist 菜单hidden属性；更新频率极低，登陆刷新，不放入定时任务
      let blacklist = []
      const blacklistResDb = await getBlacklistIndexDb()
      if (
        blacklistResDb &&
        blacklistResDb.code === 200 &&
        blacklistResDb.data
      ) {
        blacklist = blacklistResDb.data
      } else {
        blacklist = await getBlacklist(request)
      }

      // const blacklist = await getBlacklist(request)
      const filterMenu = {}
      blacklist.forEach((item) => {
        filterMenu[item.key] = item
      })
      navMenu = resourceList.reduce((pre, item) => {
        const { resourceName, resourceKey } = item
        const curMenu = filterMenu[resourceKey] || {
          key: resourceKey,
          name: resourceName,
        }
        if (!curMenu.hidden) {
          const { abbreviation } = curMenu || {}
          pre.push({
            abbreviation,
            ...getPath(curMenu),
            name: resourceName,
            key: resourceKey,
          })
        }
        return pre
      }, [])
    } catch (e) {
      console.log(e.message, '------------')
      navMenu = resourceList.map((item) => ({
        name: item.resourceName,
        key: item.resourceKey,
      }))
    }
  }
  return {
    menuList,
    filterRouter,
    navMenu,
  }
}

function getPath(item) {
  try {
    if (item && item.icon) {
      return {
        icon: item.icon,
        activeIcon: item.activeIcon || item.icon,
      }
    }
    const icon = item.key
      .split('-')
      .map((citem, ind) =>
        (ind === 0 ? citem : citem && citem[0].toUpperCase() + citem.slice(1)))
      .join('')
    const activeIcon = `${icon}_active`
    const hoverIcon = `${icon}_hover`
    return {
      icon,
      activeIcon,
      hoverIcon,
    }
  } catch (e) {
    return {}
  }
}

function getMenuList({ routers, platformName, resourceList }) {
  const menuList = getNewTreeMenu(routers, platformName, resourceList, true)
  return menuList
}

function getAuthorizedRouter({
  routers,
  platformName,
  resourceList = [],
  menuList,
}) {
  let data = resourceList.find((item) => item.resourceKey === platformName)
  if (menuList && menuList.length) {
    data = menuList
  } else {
    data = (data && data.children) || []
  }
  const filterRouter = getSubMenuList(routers, data || [])
  return filterRouter || []
}

// 获取菜单黑名单列表indexDB
function getBlacklistIndexDb() {
  return new Promise((re) => {
    db.get('resourceBlacklist', true)
      .then((res) => {
        re(res || {})
      })
      .catch((res) => {
        re(res || {})
      })
  })
}

// 获取菜单黑名单列表
async function getBlacklist(request) {
  try {
    const res = await request({
      url: '/admin/v1/config/getOnlyV2',
      method: 'post',
      data: {
        group: 'default',
        module: 'fe-web',
        configName: 'blackGlobalNavMenu',
      },
    })
    const { code, data } = res
    let value = []
    if (code === 1 && data) {
      try {
        value = JSON.parse(data.value)
      } catch (e) {
        console.log(e.message)
      }
    }
    db.save('resourceBlacklist', value, true)
    return value
  } catch (e) {
    return []
  }
}

// 静态路由扁平化
const nomalRouters = [] // 常规路由
const paramsRouters = [] // 带参数路由
function routerTreeToArr(pathStr = '', routerArr = []) {
  routerArr.forEach((item) => {
    const { path, children } = item
    if (path && path.indexOf('/') === 0) {
      pathStr = path
      if (path.includes(':') === false) {
        nomalRouters.push(path)
      } else {
        const pArr = path.split('/')
        pArr.forEach((citem, index) => {
          if (citem.includes(':')) {
            pArr.splice(index, 1, '[\\s\\S]+')
          }
        })
        paramsRouters.push(new RegExp(`/^${pArr.join('/')}$/`))
      }
      if (children && children.length > 0) {
        routerTreeToArr(pathStr, children)
      }
    } else if (children && children.length > 0) {
      routerTreeToArr(`${pathStr}/${path}`, children)
    } else if (path.includes(':') === false) {
      nomalRouters.push(`${pathStr}/${path}`)
    } else {
      const pArr = path.split('/')
      pArr.forEach((citem, index) => {
        if (citem.includes(':')) {
          pArr.splice(index, 1, '[\\s\\S]+')
        }
      })
      paramsRouters.push(new RegExp(`^${pathStr}/${pArr.join('/')}$`))
    }
  })
}

// 权限校验 true-403 false-404
function getPermission(path) {
  for (let i = 0; i < nomalRouters.length; i++) {
    if (path === nomalRouters[i]) {
      return true
    }
  }
  for (let j = 0; j < paramsRouters.length; j++) {
    if (paramsRouters[j].test(path)) {
      return true
    }
  }
  return false
}

export default {
  get,
  getMenuList,
  getAuthorizedRouter,
  routerTreeToArr,
  getPermission,
}
